// extracted by mini-css-extract-plugin
module.exports = {"inputNumber":"antd-pro-containers-course-views-styles-inputNumber"};